import { QPS_MANAGE_RIGHT, QPS_SUPERVISOR_RIGHT } from '../constants/SmartInsightConstants';

export const getHasSupervisorRight = (state) => state.userRights?.includes(QPS_SUPERVISOR_RIGHT);
export const getHasManageRight = (state) => state.userRights?.includes(QPS_MANAGE_RIGHT);
